function selectWeek(date: Date | string | number): Date[] {
  return Array(7).fill(new Date(date)).map((el, idx) =>
    new Date(el.setDate(el.getDate() - el.getDay() + idx)))
}

export default selectWeek;
